// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"library_dashboard__FQIwu","content":"library_content__YQ3Wo"};